import React from 'react';
import Header from './DataTableComponents/Header';

export default class AdvancedDataTable extends React.Component {
	constructor(props) {
		super(props);

		const data = this.props.data || [];

		this.state = {
			data: data,
			loading: false
		};
		console.log(this.state);

		this.loadData = this.loadData.bind(this);
	}

	componentDidMount() {
		if (!this.state.data || this.state.data.length === 0) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.endpoint !== this.props.endpoint) {
			this.loadData();
		}
	}

	render() {
		// console.log('AdvancedDataTable - Props', this.props);
		// console.log('AdvancedDataTable - State', this.state);
		const { margin = 'my-6', shadow = '' } = this.props;

		return (
			<div
				className={`w-full min-w-96 ${margin} border border-gray-300 rounded-md ${shadow} overflow-scroll`}
			>
				<div className="mb-0.5">
					<table className="w-full">
						<thead className="bg-gray-100">
							<tr>
								{this.props.columns.map((column) => (
									<th
										key={column.displayName}
										className={
											'px-8 py-3 text-' +
											column.alignment +
											' ' +
											this.props.style
										}
									>
										<Header
											column={column}
											onChangeSortOrder={this.props.onChangeSortOrder}
											sortOrder={this.props.sortOrder}
											sortColumn={this.props.sortColumn}
										/>
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{this.props.data.map((d) => {
								return this.props.rowRenderer(d);
							})}
							{this.state.data.map((d) => {
								return this.props.rowRenderer(d);
							})}
						</tbody>
					</table>
				</div>
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
			</div>
		);
	}

	/**
	 * Change Handlers
	*/

	/**
	 * Helper Functions 
	*/

	loadData() {
		if (this.props.endpoint) {
			this.setState({ loading: true });
			$.ajax({
				type: 'GET',
				url: this.props.endpoint
			}).done((payload) => {
				const { data } = payload;
				// console.log('loadData done', payload, data);
				this.setState({ data: data });
			});
		}
	}
}
